import React from 'react';
import { ShieldCheck, CalendarCheck, BadgePercent, Headphones } from 'lucide-react';
import { whyUs } from '../mock';

const iconMap = { ShieldCheck, CalendarCheck, BadgePercent, Headphones };

const WhyUs = () => {
  return (
    <section className="relative py-16 bg-[#0d64a8] text-white overflow-hidden">
      <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: 'radial-gradient(circle at 20% 20%, rgba(255,255,255,0.4) 0, transparent 30%), radial-gradient(circle at 80% 80%, rgba(255,255,255,0.4) 0, transparent 30%)'
      }} />
      <div className="max-w-[1280px] mx-auto px-5 lg:px-8 relative">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-6 items-center">
          <div className="md:col-span-2 space-y-5">
            {whyUs.slice(0, 2).map((f) => {
              const Icon = iconMap[f.icon];
              return (
                <div key={f.title} className="flex items-start gap-4">
                  <div className="w-14 h-14 rounded-full bg-white/15 flex items-center justify-center shrink-0">
                    <Icon size={26} />
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg mb-1">{f.title}</h4>
                    <p className="text-sm text-white/85 leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="md:col-span-1 text-center">
            <h3 className="text-3xl md:text-4xl font-bold italic">Why <br className="hidden md:block"/>Travelsera?</h3>
          </div>

          <div className="md:col-span-2 space-y-5">
            {whyUs.slice(2, 4).map((f) => {
              const Icon = iconMap[f.icon];
              return (
                <div key={f.title} className="flex items-start gap-4 md:justify-end md:text-right md:flex-row-reverse">
                  <div className="w-14 h-14 rounded-full bg-white/15 flex items-center justify-center shrink-0">
                    <Icon size={26} />
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg mb-1">{f.title}</h4>
                    <p className="text-sm text-white/85 leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
